export default __webpack_public_path__ + "static/media/Ballroll_00270.22806ef9.png";